import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface RevertCancelDealParams {
  dealId: string;
  revertPayments: boolean;
}

export const useRevertCancelDeal = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ dealId, revertPayments }: RevertCancelDealParams) => {
      // 1. Revert the deal - clear cancellation fields
      const { data: deal, error: dealError } = await supabase
        .from('deals')
        .update({
          deal_status: 'active',
          cancelled_at: null,
          cancellation_reason: null
        })
        .eq('id', dealId)
        .select()
        .single();

      if (dealError) throw dealError;

      // 2. If requested, revert cancelled payments to pending
      if (revertPayments) {
        const { error: paymentsError } = await supabase
          .from('payments')
          .update({ status: 'pending' })
          .eq('deal_id', dealId)
          .eq('status', 'cancelled');

        if (paymentsError) throw paymentsError;
      }

      return deal;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['deal'] });
      queryClient.invalidateQueries({ queryKey: ['deals'] });
      queryClient.invalidateQueries({ queryKey: ['payments'] });
      toast.success('Cancelamento revertido com sucesso');
    },
    onError: (error: Error) => {
      console.error('Error reverting deal cancellation:', error);
      toast.error('Erro ao reverter cancelamento: ' + error.message);
    }
  });
};
